module.exports = __webpack_public_path__ + "static/media/gym-button.42ba0999.jpg";